import {FeedbackRating, FeedbackReason} from "./enums";
export interface IRatingEventDetails {
    id: string;
    rating: FeedbackRating;
    messageId: string;
}

export interface IReasonEventDetails {
    id: string;
    reason: FeedbackReason;
    messageId: string;
    freeText: string | null;
}

export interface IChatMessageInputHasTextEventDetails {
    hasText: boolean;
    value: string;
}

export interface IChatMessageInputFillRecordedTextEventDetails {
    text: string;
}

export interface IChatMessageInputRequestHasTextEventDetails {
}

export interface IChatMessageInputDisableEventDetails {
}

export interface IChatMessageInputEnableEventDetails {
}

export type RatingEvent = CustomEvent<IRatingEventDetails>;
export type ReasonEvent = CustomEvent<IReasonEventDetails>;
export type ChatMessageInputHasTextEvent = CustomEvent<IChatMessageInputHasTextEventDetails>;
export type ChatMessageInputFillRecordedTextEvent = CustomEvent<IChatMessageInputFillRecordedTextEventDetails>;
export type ChatMessageInputRequestHasTextEvent = CustomEvent<IChatMessageInputRequestHasTextEventDetails>;
export type ChatMessageInputDisableEvent = CustomEvent<IChatMessageInputDisableEventDetails>;
export type ChatMessageInputEnableEvent = CustomEvent<IChatMessageInputEnableEventDetails>;

export const FEEDBACK_RATING_SUBMIT_EVENT: "feedback:rating-submit" = "feedback:rating-submit";
export const FEEDBACK_REASON_SUBMIT_EVENT: "feedback:reason-submit" = "feedback:reason-submit";
export const CHAT_MESSAGE_INPUT_HAS_TEXT_EVENT: "chat:message-input-has-text" = "chat:message-input-has-text";
export const CHAT_MESSAGE_INPUT_FILL_RECORDED_TEXT_EVENT: "chat:message-input-fill-recorded-text" = "chat:message-input-fill-recorded-text";
export const CHAT_MESSAGE_INPUT_REQUEST_HAS_TEXT_EVENT: "chat:message-input-request-has-text" = "chat:message-input-request-has-text";
export const CHAT_MESSAGE_INPUT_DISABLE_EVENT: "chat:message-input-disable" = "chat:message-input-disable";
export const CHAT_MESSAGE_INPUT_ENABLE_EVENT: "chat:message-input-enable" = "chat:message-input-enable";
